export const ZENDESK_TOKEN_INITIAL_REFETCH_INTERVAL = 1_800_000;
